import { gql } from "graphql-request";

export const getAllWhatsapp = gql`
query {
  allWhatsappLogs {
    success
    error
    message
    data {
      id
      task {
        title
      }
      assignedTo {
        username
      }
      chatDate
      chatstartTime
      chatendTime
      duration
      outcome
      followUpActions
      createdAt
    }
  }
}
`;

export const GetWhatsAppLogById = gql`
query GetWhatsAppLogById($id: Int!) {
    getWhatsappLogById(id: $id) {
      success
      error
      message
      data {
        id
        task {
          id
          title
        }
        assignedTo {
          id
          username
        }
        customer{
          id
          legalName
        }
        lead{
          id
          companyName
        }
        
        chatDate
        chatstartTime
        chatendTime
        duration
        outcome
        followUpActions
      }
    }
  }
`;

export const CreateWhatsAppLog = gql`
mutation CreateWhatsAppLog($input: CreateWhatsAppDetailsInput!) {
    createWhatsappDetails(input: $input) {
      success
      error
      message
      data {
        id
        task {
          title
        }
        assignedTo {
          username
        }
        customer {
          legalName
        }
        lead {
          firstName
        }
        chatDate
        chatstartTime
        chatendTime
        duration
        outcome
        followUpActions
        createdAt
      }
    }
  }
`;

export const UpdateWhatsappLog = gql `
mutation UpdateWhatsappLog($input: UpdateWhatsAppDetailsInput!) {
  updateWhatsappDetails(input: $input) {
    success
    error
    message
    data {
      id
      chatDate
      chatstartTime
      chatendTime
      duration
      outcome
      followUpActions
    }
  }
}
`;

export const DeleteWhatsAppLog = gql`
mutation DeleteWhatsAppLog($id: Int!) {
  deleteWhatsappDetails(id: $id) {
    success
    error
    message
  }
}
 
`;

export const getAllTask = `query { 
    allTasks {  
      success   
      message  
      data {   
        id 
        title 
        status  
        deadlineDate 
        assignedTo { 
          id 
          username 
        } 
      } 
    } 
} `;